import styled from 'styled-components';
const AlignIcon = styled.img`
  cursor: pointer;
`;

export { AlignIcon };
